
import { Component, OnInit, ViewChild, computed, inject, model, signal } from '@angular/core'
import { NgbActiveOffcanvas, NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { AppStore } from 'src/app/core/app.store'
import { StaffDetailComponent } from '../staff-detail/staff-detail.component'
import { Observable, tap } from 'rxjs'
import { MobileTracking } from 'src/app/shared/interfaces/mobile-tracking/mobile-tracking.interface'
import { MobileTrackingService } from 'src/app/core/services/mobile-tracking.service'
import { GoogleMap, GoogleMapsModule, MapInfoWindow, MapMarker } from '@angular/google-maps'
import { HttpClient } from '@angular/common/http'
import { StaffRole } from 'src/app/shared/interfaces/staff/staff-role.interface'
import { FormBuilder, ReactiveFormsModule } from '@angular/forms'
import { InputComponent } from '../../form-elements/input/input.component'
import { toSignal } from '@angular/core/rxjs-interop'

interface MapMarkerWithOptions {
    position: google.maps.LatLngLiteral
    marker: google.maps.marker.AdvancedMarkerElement
}

@Component({
    selector: 'sf-staff-pullout',
    imports: [
    ReactiveFormsModule,
    GoogleMapsModule,
    NgbNavModule,
    InputComponent,
    ButtonComponent,
    StaffDetailComponent
],
    templateUrl: './staff-pullout.component.html',
    styleUrl: './staff-pullout.component.scss',
})
export class StaffPulloutComponent {
    activeOffcanvas = inject(NgbActiveOffcanvas)
    appStore = inject(AppStore)

    #fb = inject(FormBuilder)

    search = this.#fb.control<string | null>(null)
    searchTerm = toSignal(this.search.valueChanges, { initialValue: null })
    searchPlaceholder = computed(() => {
        const count = this.staff().length
        return (
            (count === 1 ? 'Search 1 staff member' : `Search ${count} staff members`) +
            ' by name, email or vehicle registration'
        )
    })

    staff = this.appStore.staff
    filteredStaff = computed(() => {
        const term = this.searchTerm()?.toLowerCase().trim()
        if (!term) {
            return this.staff()
        }
        return this.staff().filter(
            (s) =>
                s.fullName.toLowerCase().includes(term) ||
                s.emailAddress.toLowerCase().includes(term) ||
                s.vehicle?.registration.toLowerCase().includes(term)
        )
    })

    dismiss(): void {
        this.activeOffcanvas.dismiss()
    }
    close(): void {
        this.activeOffcanvas.close()
    }
}
